module.exports = __webpack_public_path__ + "img/generalMessage.c332a79c.svg";